import React, { useMemo } from 'react';
import classNames from 'classnames';
import styles from './PlanChooser.scss';
import ArrowDownMiddleIcon from '../../../../assets/images/arrow-down-middle-15x15.svg';
import { __ } from '../../../../core/utils';

export const PlanChooser = ({
  label,
  firstColor = '#E74C3C',
  secondColor = '#5676fc',
  items = [],
  activeFirstPlanId,
  activeSecondPlanId,
  isOpen,
  onToggle,
  onSelect,
  topOffset,
  onSlotSwitch,
  source = 'first',
  isSlotActive,
}) => {
  const dotStyle = (color) => {
    return {
      background: color,
      boxShadow: `inset 0 0 0 2px #FFF, 0 0 0 1px ${color}`,
    };
  };

  const headerDotClick = (e) => {
    e.stopPropagation();
    onSlotSwitch(source);
  };

  return (
    <div
      className={styles.planChooser}
      style={isOpen ? { borderBottom: 'solid #80CEFD 3px' } : undefined}
    >
      <div className={styles.dotWrapper} onClick={headerDotClick}>
        <span
          className={styles.dot}
          style={isSlotActive ? dotStyle(firstColor) : {}}
        />
      </div>

      <span
        className={styles.title}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') onToggle();
        }}
      >
        {label}
      </span>
      <ArrowDownMiddleIcon
        className={classNames(isOpen && styles.rotate)}
        onClick={onToggle}
      />

      {isOpen && (
        <div
          className={styles.items}
          style={topOffset ? { top: topOffset } : undefined}
        >
          {items.length === 0 && (
            <div className={styles.empty}>{__('No versions')}</div>
          )}
          {items.map((plan) => {
            const planId = plan?.id;
            const activeFirstPlan = planId && activeFirstPlanId === planId;
            const activeSecondPlan = planId && activeSecondPlanId === planId;
            const colorStyle = activeFirstPlan
              ? dotStyle(firstColor)
              : activeSecondPlan
              ? dotStyle(secondColor)
              : {};

            return (
              <div
                key={planId}
                className={classNames(
                  styles.item,
                  (activeFirstPlan || activeSecondPlan) && styles.disabled
                )}
                onClick={(e) => {
                  e.stopPropagation();
                  if (planId && !(activeFirstPlan || activeSecondPlan))
                    onSelect(planId);
                }}
                role='button'
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.stopPropagation();
                    if (planId && !(activeFirstPlan || activeSecondPlan))
                      onSelect(planId);
                  }
                }}
              >
                <span className={styles.dot} style={colorStyle} />
                <span className={styles.title}>{plan?.title}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
